import { type CreditCardAccountConstructor } from '@webapp/modules/accounts-payable/entities/CreditCardAccount'
import { type ReconcileSessionConstructor } from '@webapp/modules/accounts-payable/entities/ReconcileSession'
import {
  type CreditCardAccountApiModel,
  type CreditCardAccountSessionApiModel,
} from '../api-models/CreditCardAccountApiModel'

const mapSession = (
  session: CreditCardAccountSessionApiModel
): ReconcileSessionConstructor => ({
  id: session.id,
  uuid: session.uuid,
  status: session.status,
  balance: session.balance,
  statementDate: session.statement_date,
  lockStatus: {
    isLocked: session.lock_status.is_locked,
    lockedBy: session.lock_status.locked_by,
  },
  billUuid: session.bill_uuid,
  billGroup: session.bill_group,
  creditcardId: session.creditcard,
})

export const mapCreditCardAccountApiModel = (
  model: CreditCardAccountApiModel
): CreditCardAccountConstructor => ({
  id: model.id,
  name: model.name,
  number: model.number,
  type: model.type,
  currency: {
    id: model.currency.id,
    name: model.currency.name,
    rate: parseFloat(model.currency.rate),
    base: model.currency.base,
  },
  vendor: {
    id: model.vendor.id,
    name: model.vendor.name,
  },
  glCode: model.gl_code || '',
  assignees: model.assignees.map((assignee) => ({
    id: assignee.id,
    firstName: assignee.firstName,
    lastName: assignee.lastName,
    email: assignee.email,
    position: assignee.position,
    profileImage: assignee.profile_image,
  })),
  lastReconciliationDate: model.last_reconciliation_date,
  lastReconciliationBalance: model.last_reconciliation_balance,
  lastStatementDate: model.last_statement_date,
  session: model.session ? mapSession(model.session) : null,
})
